import { RoomType } from 'proto/Offer/Room/RoomType';

const roomTypeToUrlValueMap: Partial<Record<RoomType, string>> = {
    [RoomType.Apartment]: 'apartment',
    [RoomType.Bungalow]: 'bungalow',
    [RoomType.Chalet]: 'chalet',
    [RoomType.DeluxeBedRoom]: 'deluxe',
    [RoomType.DoubleBedRoom]: 'double',
    [RoomType.DuplexBedRoom]: 'duplex',
    [RoomType.Economy]: 'economy',
    [RoomType.FamilyRoom]: 'family',
    [RoomType.FourBedRoom]: 'fourbedroom',
    [RoomType.HolidayFlat]: 'holidayflat',
    [RoomType.HolidayHouse]: 'holidayhouse',
    [RoomType.Houseboat]: 'houseboat',
    [RoomType.JuniorSuite]: 'juniorsuite',
    [RoomType.Mobile]: 'mobile',
    [RoomType.MultiShareRoom]: 'multishare',
    [RoomType.Program]: 'program',
    [RoomType.SingleBedRoom]: 'single',
    [RoomType.Studio]: 'studio',
    [RoomType.Suite]: 'suite',
    [RoomType.Superior]: 'superior',
    [RoomType.Tent]: 'tent',
    [RoomType.TentPitch]: 'tentpitch',
    [RoomType.TripleBedRoom]: 'triple',
    [RoomType.TwinRoom]: 'twinroom',
    [RoomType.VacationHome]: 'vacationhome',
    [RoomType.Villa]: 'villa',
    [RoomType.WaterBungalow]: 'waterbungalow',
};

const urlValueToRoomTypeMap: Partial<Record<string, RoomType>> =
    Object.fromEntries(
        Object.entries(roomTypeToUrlValueMap).map(([key, value]) => [
            value,
            key as RoomType,
        ])
    );

export const convertRoomTypeToUrlValue = (roomType: RoomType) =>
    roomTypeToUrlValueMap[roomType];

export const convertUrlValueToRoomType = (urlValue: string) =>
    urlValueToRoomTypeMap[urlValue];
